import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { ReservationService } from '@uzurv/clara';
import {
  DistanceConversionProvider,
  TimeConversionProvider,
  TimezoneDateProvider,
  UzurvDirectivesModule,
  UzurvPipesModule
} from '@uzurv/core';
import { ChatModule } from '../../chat';
import { DialogModule } from '../../dialogs/dialog.module';
import { RequiresPermissionsModule } from '../../directives';
import { EtaModule } from '../../eta/eta.module';
import { SelectDriverModule } from '../../select-driver/select-driver.module';
import { ReservationDetailMapComponent } from './reservation-detail-map';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    DialogModule,
    SelectDriverModule,
    ChatModule,
    UzurvPipesModule,
    UzurvDirectivesModule,
    EtaModule,
    RequiresPermissionsModule
  ],
  declarations: [ReservationDetailMapComponent],
  exports: [ReservationDetailMapComponent],
  providers: [ReservationService, DistanceConversionProvider, TimeConversionProvider, TimezoneDateProvider]
})
export class ReservationDetailModule {}
